const GuineaBissauSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111553)">
      <path
        d="M19.9999 0C18.1948 0 16.446 0.240625 14.7825 0.688984L13.0435 20L14.7826 39.311C16.446 39.7594 18.1948 40 19.9999 40C31.0456 40 39.9999 31.0456 39.9999 20C39.9999 8.95437 31.0456 0 19.9999 0Z"
        fill="#FFDA44"
      />
      <path
        d="M13.0435 20L14.7826 39.311C16.446 39.7594 18.1948 40 19.9999 40C31.0456 40 39.9999 31.0456 39.9999 20H13.0435Z"
        fill="#6DA544"
      />
      <path
        d="M0 20.0008C0 27.5817 4.21797 34.177 10.4348 37.569V2.43262C4.21797 5.82465 0 12.42 0 20.0008Z"
        fill="#D80027"
      />
      <path
        d="M0 19.9995C0 29.24 6.26727 37.0155 14.7826 39.3105V0.688477C6.26727 2.98348 0 10.7589 0 19.9995Z"
        fill="#D80027"
      />
      <path
        d="M7.55813 14.7832L8.85305 18.7688H13.0441L9.65367 21.2323L10.9485 25.218L7.55813 22.7547L4.16758 25.218L5.46273 21.2323L2.07227 18.7688H6.26313L7.55813 14.7832Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111553">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default GuineaBissauSvg;
